module.exports = __webpack_public_path__ + "img/orchid.be5030ca.webp";